module.exports = __webpack_public_path__ + "media/assets/dropdown-4c00e7c83198178dacc4568c6fc6fd3984360fb1af818614e4afed1047be4d49.svg";